module.exports = __webpack_public_path__ + "img/attention.e2a8f9bd.svg";